















import Vue from 'vue';
import { recognition, AccountLogo, ParentAccountLogo } from 'mycorems-app-accounts';

export default Vue.extend({
  computed: {
    accountId(): string|null {
      return recognition.getAccountId();
    },
    isAgency(): boolean {
      return recognition.isAgency();
    },
    isClient(): boolean {
      return recognition.isClient();
    },
  },
  components: {
    AccountLogo,
    ParentAccountLogo,
  },
});
